import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest} from "@angular/common/http";

import {AgentUtility} from "../util";
//import {CountTimer} from "./perfomance.service";
import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {ResponseApi} from "./response/response";
import {CountTimer} from "./perfomance.service";
import {TimerModel} from "./response/TimerModel";
import {AppSettings} from "../app.settings";
import { SSOUtility } from "../util/sso.utility";
import { fromPromise } from 'rxjs/internal-compatibility';
declare let keycloak:any;

@Injectable()
export class Base2Service {

    public headers: HttpHeaders;
    public agentUtility: AgentUtility;
    public onStart: any;
    public onEnd: any;
    private keycloakAdapter:any;

    constructor(private _http: HttpClient, private _countTimer: CountTimer) {   
        this.agentUtility = new AgentUtility();
    }
    getFile(filter: any, type: string): Observable<any> {
        let localuser = AgentUtility.getUser();


        let url = "";
        if (type == 'contracts') {
            filter.AgentId = localuser.Id;
            url = type;
        }
        else {
            url = 'events';
        }
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + url, filter);
    }
    request<T>(methodName: string, url: string, datarequest?: any, headers?: HttpHeaders): Observable<T> {      
        return fromPromise(SSOUtility.refreshToken())
        .flatMap(() => {
            this.headers = new HttpHeaders({
                'content-type': 'application/json',
                'Accept': 'Authorization',
                'Authorization':'Bearer '+ AgentUtility.getToken(),
                'Cache-Control': 'no-cache, must-revalidate'
            });
            if(headers)
                headers.set('Authorization','Bearer '+ AgentUtility.getToken());
            const timerModel: TimerModel = new TimerModel();
            this._countTimer.add(timerModel);
            let request: Observable<T>;
            if (methodName === 'GET') {
                request = this._http.get<T>(url, {headers: this.headers});
            } else if (methodName === 'POST') {
                request = this._http.post<T>(url, datarequest, {headers: (headers != null && headers != undefined) ? headers : this.headers});
            } else if (methodName === 'DELETE') {
                request = this._http.delete<T>(url, {headers: headers != null ? headers : this.headers});
            } else {
                request = this._http.put<T>(url, datarequest, {headers: this.headers});
            }
            const result: Observable<T> = Observable.create(observable => {
                if(this.onStart != null){
                    this.onStart();
                }
                let unsubscribe = request.subscribe((data: T) => {
                    timerModel.Finish();
                    if(this.onEnd != null){
                        this.onEnd();
                    }
                    observable.next(data);
    
                }, (err) => {
                    observable.next(err);
                });
                //unsubscribe.unsubscribe();
            });
            return result;
        })   
    }

}

